import React, { useState, useEffect } from "react";

import { HashRouter, Route, Switch } from "react-router-dom"; // Import HashRouter instead of BrowserRouter
import "./App.css";
import Scheduler from "./components/Scheduler";
import Mascot from "./components/Mascot";
import AboutUs from "./components/AboutUs";
import CommunityJoin from "./components/CommunityJoin";
import Navbar from "./components/Navbar";
import Partner from "./pages/Partner";
import Foooter from "./components/Foooter";
import Member from "./pages/Member";
import Service from "./pages/Service";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import TimeLine from "./components/TimeLine";
import Contrib from "./pages/Contrib";
import Mascots from "./pages/Mascots";

function App() {
  const [eventData, setEventData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      const eventDataFromParser = window.ExtractedData;
      if (eventDataFromParser) {
        setEventData(eventDataFromParser);
        setIsLoading(false);
      } else {
        console.error("Parsed data is not available.");
        setIsLoading(false);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <HashRouter>
      <div className="App">
        <Navbar />
        <div className="min-w-screen w-full h-full">
          <Switch>
            <Route path="/partners">
              <Partner />
            </Route>
            <Route path="/mascot">
              <Mascots />
            </Route>
            <Route path="/members"> 
              <Member />
            </Route>
            <Route path="/service">
              <Service />
            </Route>
            <Route path="/about">
              <About />
              <TimeLine />
            </Route>
            <Route path="/gallery">
              <Gallery />
            </Route>
            <Route path="/attribution">
              <Contrib />
            </Route>
            <Route path="/">
              <Mascot />
              <Scheduler eventData={eventData} />
              <AboutUs />
              <CommunityJoin />
            </Route>
          </Switch>
        </div>
        <Foooter />
      </div>
    </HashRouter>
  );
}

export default App;